<template>
  <div>
    <div class="grid-content container">
      <div class="float-layout overlay">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col class="w17-percent">
            <span>当天产能产线负荷情况</span>
          </a-col>
          <a-col class="w5-percent">
            <span>供应商</span>
          </a-col>
          <a-col class="w17-percent">
            <global-select
              v-model="queryParams.vendorCode"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpProductionScheduling/listPcSupplier"
              :selectItem="{ value: 'realValue', label: 'label' }"
              @change="handleVendorChange"
            />
          </a-col>
          <a-col class="w7-percent">
            <span>排产日期</span>
          </a-col>
          <a-col class="w54-percent">
            <a-date-picker v-model="queryParams.startDateMoment" @change="onChange" />
          </a-col>
        </a-row>
      </div>
      <div class="content" id="ipage-chart-send" ref="send"></div>
    </div>
  </div>
</template>

<script>
import { lineCnSearchDay } from "@/api/scp/productionScheduling/schedulingWorkbench.js"
import * as echarts from 'echarts'
import moment from 'moment'
export default {
  name: 'SchedulingInfoTable',
  components: {},
  mounted () {
    this.renderChart({
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      grid: {
        top: '15%',
        left: '2%',
        right: '2%',
        bottom: '5%',
        containLabel: true
      },
      series: [
        {
          data: [],
          type: 'bar'
        }
      ]
    })
  },
  data () {
    // 查询参数
    return {
      queryParams: {
        vendorCode: '',
        startDate: '',
        startDateMoment: ''
      }
    }
  },
  methods: {
    setQueryParamsAndQuery (vendorCode, startDate) {
      this.queryParams.startDate = startDate
      this.queryParams.startDateMoment = moment(startDate)
      if (vendorCode) {
        this.queryParams.vendorCode = vendorCode
        this.initData()
      }
    },
    renderChart (option) {
      const myChart = echarts.init(this.$refs.send)
      option && myChart.setOption(option)
    },
    handleVendorChange (val) {
      if (this.queryParams.startDate) {
        this.initData()
      }
    },
    onChange (val) {
      this.queryParams.startDate = val.format('YYYY-MM-DD')
      if (this.queryParams.vendorCode) {
        this.initData()
      }
    },
    initData () {
      lineCnSearchDay({
        vendorCode: this.queryParams.vendorCode,
        startDate: this.queryParams.startDate
      }).then(res => {
        console.log(res)
        this.renderChart({
          xAxis: {
            type: 'category',
            data: res.map(item => item.lineCode)
          },
          grid: {
						top: '15%',
						left: '2%',
						right: '2%',
						bottom: '5%',
						containLabel: true
					},
					yAxis: {
						name: '%',
						type: 'value'
					},
          tooltip: {
						trigger: 'item',
            valueFormatter: (value) => `${parseFloat(value.toFixed(4))}%`
					},
          series: [
            {
              data: res.map(item => item.lineLoad * 100),
              type: 'bar'
            }
          ]
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.grid-content {
  width: 100%;
  border-radius: 4px;
  min-height: 36px;
  background: rgb(255, 255, 255);
}

.container {
  position: relative;
  // width: 300px;
  // height: 200px;
  // height: 200px;
  // width: 1000px
}

.overlay {
  // position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  // z-index: 2;
  /* 设置较高的 z-index 值 */
}

.content {
  position: relative;
  // z-index: 1;
  /* 设置较低的 z-index 值 */
  height: 250px;
  // width: 1000px
}

/deep/.ant-select {
  width: 150px;
}

.w17-percent {
  width: 17%;
}

.w7-percent {
  width: 7%;
}

.w5-percent {
  width: 5%;
}

.w54-percent {
  width: 54%;
}

.w100-percent {
  width: 100%;
}</style>
